/*
 * @Author: weiyanna
 * @Date: 2022-03-25 13:55:32
 * @LastEditTime: 2026-04-29 20:58:32
 * @LastEditors: weiyanna weiyanna@jd.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /isp_International/src/api/newApi/carts.ts
 */
import http, { messageHttp } from '../axios';
import type { CartGroupListResponse, PalletGroupHeaderResponse } from './pallet';

// 国际站接口

type CartNumResponse = Record<string, any>;

let cachedCartNum: CartNumResponse | null = null;
let inflightCartNum: Promise<CartNumResponse> | null = null;

function requestCartNum(params: any = {}, loading = true) {
  return new Promise<CartNumResponse>((resolve, reject) => {
    http('get', '/jdig/cart/getCartNum', params, loading, true).then(
      (res: CartNumResponse) => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

export function clearCartNumCache() {
  cachedCartNum = null;
  inflightCartNum = null;
}

/** 加购/删改数量后同步内存缓存，避免 NavBar 仍命中旧的 getCartNum 结果 */
export function syncCartNumCache(num: number) {
  cachedCartNum = { success: true, value: num };
}

/**
 * 获取采购清单数量
 * 全站复用：同一时刻只发起一次 /jdig/cart/getCartNum 请求
 */
export function getCartNum(params: any = {}, loading = true, forceRefresh = false) {
  if (!forceRefresh && cachedCartNum) {
    return Promise.resolve(cachedCartNum);
  }

  if (!forceRefresh && inflightCartNum) {
    return inflightCartNum;
  }

  inflightCartNum = requestCartNum(params, loading)
    .then(res => {
      cachedCartNum = res;
      return res;
    })
    .catch(error => {
      console.log('网络异常~', error);
      throw error;
    })
    .finally(() => {
      inflightCartNum = null;
    });

  return inflightCartNum;
}

/**
 * 购物车列表
 * @param params
 */
export function getCartList(params: Record<string, unknown> = {}, loading = true) {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/cart/getCartList', params, loading, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

/** 政企-多货盘分组列表入参。 */
interface CartGroupListParams {
  /** true 时后端跳过首屏库存，随后由 getCartSaleStock 按 sku 补齐。 */
  deferSaleStock?: boolean;
  /** 当前地址链路 code 数组，来自 util/requestAddressInfo#getCurrentAddressInfo。 */
  addressInfo?: number[];
  [key: string]: any;
}

/**
 * 政企-多货盘分组列表（F-002）。
 * 命中货盘开关（settings/auth 的 O_palletEnabled）时首屏调用；deferSaleStock=true 时后端跳过首屏库存，
 * 与平铺两段加载对齐，随后仍调 getCartSaleStock 按 sku 补齐。
 */
export function getCartGroupList(
  params: CartGroupListParams = {},
  loading = true,
): Promise<CartGroupListResponse> {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/cart/getCartGroupList', params, loading, true).then(
      (res: CartGroupListResponse) => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

/**
 * 凑单页轻量组头（F-006 性能优化第 3 步，2026-10-25 拍板）。
 * 只回组头字段+totalKindCount，不回 waresList 明细，替代凑单页对 getCartGroupList 全量分组的依赖；
 * value 可能为 null（入参空/目标盘无商品/下游异常降级），调用方按 groupMissing 兜底。
 */
export function getPalletGroupHeader(
  params: { palletCode?: string | number | null; [key: string]: any } = {},
  loading = true,
): Promise<PalletGroupHeaderResponse> {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/cart/getPalletGroupHeader', params, loading, true).then(
      // value 由 PalletGroupHeaderResponse 声明为 PalletGroupHeader | null，类型层面强制调用方做空值兜底
      (res: PalletGroupHeaderResponse) => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

export function getCartSaleStock(params: any = {}, loading = false) {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/cart/getCartSaleStock', params, loading, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}
/**
 * 根据商品名称搜索商品
 * @param params
 */
export function searchCartByName(params: any = {}, loading = true) {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/cart/searchByName', params, loading, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}
/**
 * 修改购物车商品数量
 * @param params
 */
export function updateProductNum(params: any = {}) {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/cart/updateProductNum', params, true, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

/**
 * 获取单个mku库存数量（含交期文案）。
 * 默认不展示全局转圈：商详交期为异步补齐，转圈会打断浏览。
 */
export function getRemainStock(params: any, isLoading = false) {
  return new Promise((resolve, reject) => {
    http('jsonpost', '/jdig/stock/remain', params, isLoading, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

/**
 * 新增购物车
 * @param params
 */
export function getAddProducts(params: any) {
  return new Promise((resolve, reject) => {
    http('jsonpost', '/jdig/cart/addProducts', params, true, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

/**
 * 批量立即购买
 * @param params
 */
export function batchToBuy(params: any) {
  return new Promise((resolve, reject) => {
    http('jsonpost', '/jdig/trade/batch/ispBuyNow', params, true, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

/**
 * 购物车正选反选接口
 * @param params
 */
export function checkProduct(params: any) {
  return new Promise((resolve, reject) => {
    http('jsonpost', '/jdig/cart/checkProduct', params, true, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

/**
 * 删除商品
 * @param params
 */
export function delProducts(params: any) {
  console.log('删除商品', params);
  return new Promise((resolve, reject) => {
    http('jsonpost', '/jdig/cart/delProducts', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

export function getLogin(params: any = {}) {
  return new Promise((resolve, reject) => {
    http('jsonpost', '/jdig/login', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

// 显式类型，避免与 requestPersonInfo 返回类型互相引用（TS2456）
type PersonInfoResponse = Record<string, any>;

let cachedPersonInfo: PersonInfoResponse | null = null;
let inflightPersonInfo: Promise<PersonInfoResponse> | null = null;

function requestPersonInfo(params: any = {}) {
  return http('get', '/jdig/account/me', params, false, true) as Promise<PersonInfoResponse>;
}

export function clearPersonInfoCache() {
  cachedPersonInfo = null;
  inflightPersonInfo = null;
}

/** 全站复用：同一时刻只发起一次 /jdig/account/me 请求 */
export function getPersonInfo(params: any = {}, forceRefresh = false) {
  if (!forceRefresh && cachedPersonInfo) {
    return Promise.resolve(cachedPersonInfo);
  }

  if (!forceRefresh && inflightPersonInfo) {
    return inflightPersonInfo;
  }

  inflightPersonInfo = requestPersonInfo(params)
    .then(res => {
      cachedPersonInfo = res;
      return res;
    })
    .catch(error => {
      console.log('网络异常~', error);
      throw error;
    })
    .finally(() => {
      inflightPersonInfo = null;
    });

  return inflightPersonInfo;
}

export function getPunchoutOrder(data: { orderId: string }) {
  return new Promise((resolve, reject) => {
    http('jsonpost', '/jdig/order/punchoutOrder', data, true, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

